import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=380ae73f&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380ae73f')) {
      api.createRecord('380ae73f', component.options)
    } else {
      api.reload('380ae73f', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=380ae73f&", function () {
      api.rerender('380ae73f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4KDbAWZsR9hBC/JS/comp/ServiceHelp.vue"
export default component.exports